<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<div class="filter-bar">
  <div class="filter-card">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-card__wide">
      <mat-label>Archivo (fecha del corte · nombre)</mat-label>
      <mat-select [(ngModel)]="selectedLoadId" (selectionChange)="onLoadChange()" [disabled]="loadsList.length === 0">
        @for (l of loadsList; track l.id; let first = $first) {
          <mat-option [value]="l.id">{{ loadLabel(l) }}{{ first ? ' (más reciente)' : '' }}</mat-option>
        }
      </mat-select>
      <mat-icon matPrefix>description</mat-icon>
    </mat-form-field>
    <app-search-pill [value]="filterText" [placeholder]="kind === 'PLANTA' ? 'Planta, CFN, lote, Sloc…' : 'Cuenta, CFN, UPN, lote, serie…'" (search)="applyFilter($event)"></app-search-pill>
    <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-filter-chips [count]="dataSource?.data?.length" [total]="rows?.length" noun="renglones"></app-filter-chips>
</div>

<div class="list-actions">
  <button mat-stroked-button (click)="pageLoad.refresh(refresh())"><mat-icon>refresh</mat-icon> Actualizar</button>

  <button mat-stroked-button [matMenuTriggerFor]="menu"><mat-icon>table_view</mat-icon> Excel y más</button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item [disabled]="rows.length === 0" (click)="downloadSnapshot()">
      <mat-icon>download</mat-icon>Descargar corte (xlsx)
    </button>
    <button mat-menu-item (click)="downloadSampleFile()">
      <mat-icon>description</mat-icon>Archivo muestra (Carga xlsx)
    </button>
    <button mat-menu-item [disabled]="loadsList.length === 0" (click)="toggleLoads()">
      <mat-icon>history</mat-icon>{{ showLoads ? 'Ocultar historial de cargas' : 'Historial de cargas' }}
    </button>
  </mat-menu>
  @if (permissions['create']) {
    <button mat-flat-button color="primary" (click)="openUploadSnapshot()">
      <mat-icon>upload</mat-icon>Cargar corte (xlsx)
    </button>
  }
</div>

@if (selectedLoadId) {
  <div class="kpi-row">
    @for (kpi of kpis; track kpi.label) {
      <div class="kpi">
        <span class="kpi__value">{{ kpi.value }}</span>
        <span class="kpi__label">{{ kpi.label }}</span>
      </div>
    }
  </div>

  <p class="readonly-note">
    <mat-icon inline>lock</mat-icon>
    Espejo de SAP ({{ kind === 'PLANTA' ? 'plantas y FSL' : 'cuentas de consigna' }}): no se edita, se carga un corte nuevo.
    @if (lastLoad) {
      <span> Este archivo se cargó el {{ formatDate(lastLoad.createdOn) }} ({{ lastLoad.rowCount }} renglones).</span>
    }
  </p>

  @if (showLoads) {
    <div class="loads">
      <h3>Historial de cargas</h3>
      @if (loadsList.length === 0) {
        <p class="loads__empty">Todavía no hay cortes cargados.</p>
      }
      @for (load of loadsList; track load.id) {
        <button type="button" class="loads__row" [class.loads__row--active]="load.id === selectedLoadId" (click)="selectLoad(load.id)">
          <mat-icon>{{ load.status === 'APLICADO' ? 'check_circle' : 'error' }}</mat-icon>
          <span><b>{{ loadLabel(load) }}</b></span>
          <span>{{ formatDate(load.createdOn) }}</span>
          <span>{{ load.rowCount }} renglones · {{ load.totalQuantity }} piezas</span>
          <span class="loads__status">{{ load.status }}</span>
        </button>
      }
    </div>
  }

  @if (tableData.data.length > 0 && listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (r of cardRows; track $index) {
        <div class="cat-card">
          <div class="cat-card__head">
            <span class="cat-card__title">{{ r[cardFields.title] || '—' }}</span>
            <span class="list-status">{{ r[meta.qty] ?? 0 }} pzs</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__value">{{ r[cardFields.sub] || '—' }}</span></div>
            @for (f of cardFields.fields; track f) {
              <div class="cat-card__field"><span class="cat-card__label">{{ f }}:</span><span class="cat-card__value">{{ r[f] ?? '—' }}</span></div>
            }
          </div>
        </div>
      }
    </div>
    @if (tableData.data.length > cardLimit) {
      <div class="list-actions"><button mat-stroked-button (click)="cardLimit = cardLimit + 60"><mat-icon>expand_more</mat-icon> Ver más ({{ tableData.data.length - cardLimit }} restantes)</button></div>
    }
  } @else if (tableData.data.length > 0) {
    <app-custom-table [tableData]="tableData" [filters]="[]"></app-custom-table>
  } @else {
    <p class="empty">Este corte no tiene renglones.</p>
  }
} @else {
  <p class="empty">Todavía no hay cortes cargados. Usa "Cargar corte (xlsx)" con el reporte de {{ meta.title }} que sale de SAP (descarga el archivo muestra para ver las columnas).</p>
}
